import { AfterViewInit, Component, OnInit } from '@angular/core';
import { EventService } from '../../controller/event.service';
import { registerLocaleData, Location } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { CoreService } from '../../../../helper/core/core.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TealiumUtagService } from '../../../../tealium/utag.service';

@Component({
  selector: 'app-register-dates',
  templateUrl: './register-dates.component.html',
  styles: []
})
export class RegisterDatesComponent implements OnInit, AfterViewInit {

  public objectKeys = Object.keys;
  public today: Date = new Date();
  public showSlotsRemaining: boolean = true
  public eventSubject = '';
  constructor(
    public EventController: EventService,
    public coreService: CoreService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private tealium: TealiumUtagService
  ) { }

  ngOnInit() {
    registerLocaleData(localeFr);
    window.scroll(0, 0);

    this.route.queryParams
      .filter(params => params.sessionId)
      .subscribe(params => {
        console.log('test',params)
        this.EventController.dataForm.chosenDateId = params.sessionId
      });


    this.eventSubject = this.EventController.event.name

    // Redirige automatiquement à l'étape d'après seulement si l'étape 2 à déjà été validé
    if (this.EventController.event) {
      if (this.EventController.dataForm.chosenDateId !== null && this.EventController.dataForm.validStep <= 1) {
        this.nextStep();
      }
    }
    else {
      if (this.EventController.dataForm.chosenDateId !== null && this.EventController.dataForm.validStep <= 2) {
        this.nextStep();
      }
    }
  }

  /**
   * Envoie les infos utag
   * @param track_zone | string : Nom du tracking
   * @param track_nom | string : Nom du tracking
   * @param track_cible | string : Slug du tracking
   */
   public sendLink(track_zone, track_nom, track_cible = "") {
    this.tealium.link({
      'track_zone': this.route.snapshot.paramMap.get('bu') + '_' + track_zone,
      'track_nom': track_nom,
      'track_cible': window.location.href + '/' + track_cible
    });
  }

  openOnMobile(index) {
    document.getElementById(`${index}-date`).classList.toggle("open")
  }

  ngAfterViewInit(): void {
    if (window.matchMedia("(min-width: 1024px)").matches) {
      setTimeout(() => {
        $('#event-other__slider').addClass('swiper-container');
        this.initSliderSlots()
      }, 400);
    }
  }


  private initSliderSlots(): void {
    $('.event__slider-slots').each((index, element) => {

      $(element).addClass('swiper-' + index);
      $(element).find(".swiper-button-prev").addClass("btn-prev-" + index);
      $(element).find(".swiper-button-next").addClass("btn-next-" + index);

      new Swiper('.swiper-' + index, {
        loop: false,
        slidesPerView: 4,
        spaceBetween: 0,
        slideClass: 'swiper-slide',
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      })

    });
  }

  public formValid(): boolean {
    return this.EventController.dataForm.chosenDateId == null
  }

  public nextStep() {
    this.EventController.dataForm.step += 1;
    this.EventController.dataForm.validStep = this.EventController.dataForm.step;
    var slug = this.EventController.event.slug;
    var buSlug = this.EventController.event.buSlug;
    var underscored_slug = slug.replace('-','_')
    var underscored_buSlug = buSlug.replace('-','_')
    utag.link({
      'type_page':'inscription',
      'domaine':'do',
      'titre_page': underscored_buSlug + '_-_' + underscored_slug + '_-_select_slot',
      'track_zone' : underscored_buSlug + '_-_' + underscored_slug + '_-_register',
      'track_nom' : 'choix_date',
      'track_cible' :  window.location.origin + '/' + buSlug + '/' + slug + '/' + 'register'
    });

    this.router.navigate([], { queryParams: { sessionId: this.EventController.dataForm.chosenDateId }, queryParamsHandling: 'merge' });
  }

  private linkToregister(idSlot, nbPlaces): void {
    if (nbPlaces) {
      if (this.EventController.dataForm.chosenDateId == idSlot) {
        this.EventController.dataForm.chosenDateId = null
        this.EventController.dataForm.remainingPlaces = null
        this.EventController.dataForm.commentary = null
      } else {
        this.EventController.dataForm.chosenDateId = idSlot
        this.coreService.getSlot(idSlot).subscribe(
          (data) => {
            this.showSlotsRemaining = true;
            this.EventController.dataForm.dataSlot = data
            this.EventController.dataForm.remainingPlaces = data.remainingPlaces
            this.EventController.dataForm.commentary = data.commentary
          })
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/screens/register-event/view/register-dates/register-dates.component.ts